import { TypedDocumentNode } from '@apollo/client';
import { useQuery } from '@apollo/client/react';
import { CloudControllerQueriesGetCloudControllerArgs, Query } from 'graphql/generated/graphqlTypes';
import { GET_CLOUD_CONTROLLER } from 'graphql/v2/queries';
import { useEffect } from 'react';
import { TranslatedHookProps } from '../hooks.types';

interface Props extends TranslatedHookProps {
  cloudControllerId: string;
}

// Typing the document (instead of passing generics to the Apollo hook) avoids the deprecated hook signatures.
const GET_CLOUD_CONTROLLER_TYPED: TypedDocumentNode<
  Pick<Query, 'cloudController'>,
  CloudControllerQueriesGetCloudControllerArgs
> = GET_CLOUD_CONTROLLER;

const useCloudControllerDetails = ({ translation, handleFetchError, cloudControllerId }: Props) => {
  // Off so a refetch does not blank content that is already on screen.
  const { loading, error, data, refetch } = useQuery(GET_CLOUD_CONTROLLER_TYPED, {
    variables: { cloudControllerId },
    notifyOnNetworkStatusChange: false
  });

  useEffect(() => {
    if (error) {
      handleFetchError(translation.cloud_controller_error_fetching);
      console.error(error);
    }
  }, [error]);

  return {
    cloudController: data?.cloudController.getCloudController,
    cloudControllerLoading: loading && !data,
    hasCloudControllerFetchError: Boolean(error),
    // A failed retry is already reported through `error`, so the rejection is only swallowed here.
    retryFetchingCloudController: () => refetch().catch(() => undefined)
  };
};

export default useCloudControllerDetails;
